import { Injectable } from '@angular/core';
import { DsrModeSwitcherService } from '@desyre/angular-material';

@Injectable({
  providedIn: 'root'
})

export class ThemeService {

  constructor(private dsrModeSwitcherService: DsrModeSwitcherService) { }
  
  setThemeMode(mode: 'light' | 'dark') {
    this.dsrModeSwitcherService.setMode(mode);
  }

  getThemeMode() {
    return this.dsrModeSwitcherService.getMode();
  }

  getLogoBasedOnTheme() {
    return 'assets/images/' + (this.getThemeMode() === 'light' ? 'rg-brand' : 'rg-brand') + '.svg';
  }

}